export default __webpack_public_path__ + "static/media/logo-large.73b59265.svg";